export default __webpack_public_path__ + "static/media/mb_login_image_2_min.9fb140e6.jpg";